<template>
    <v-card class="p-4 w-100 mr-4 delegation">
        <v-toolbar class="shadow-none" style="flex: unset;" content-class="h-auto">
            <div class="custom-icon-wrapper">
                <v-icon @click="backToDashboardsPage()">custom-icon left-arrow-icon</v-icon>
            </div>
            <v-toolbar-title class="size-16 dark-text p-4 label">{{ $t("res_TabsName_CorrespondenceDashboard")
            }}</v-toolbar-title>
        </v-toolbar>
        <hr>
        <div class="container">
            <v-row>
                <v-col cols="4">
                    <v-label class="label_required mb-1">{{ $t("res_Label_FromDate") }}<span> *</span></v-label>
                    <v-menu content-class="p-0" class="with-absolute-button" v-model="fromDateMenu"
                        :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field class="shrink dtField" label="Select Date"
                                :value="utils.dateFormat(filter.fromDate)" solo v-on="on" append-icon="mdi-calendar">
                                <template v-slot:append>
                                    <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                </template>
                            </v-text-field>
                        </template>
                        <v-date-picker v-model="filter.fromDate" @input="fromDateMenu = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="4">
                    <v-label class="label_required mb-1">{{ $t("res_Label_ToDate") }}<span> *</span></v-label>
                    <v-menu content-class="p-0" class="with-absolute-button" v-model="toDateMenu"
                        :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field class="shrink dtField" label="Select Date"
                                :value="utils.dateFormat(filter.toDate)" solo v-on="on" append-icon="mdi-calendar">
                                <template v-slot:append>
                                    <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                </template>
                            </v-text-field>
                        </template>
                        <v-date-picker v-model="filter.toDate" @input="toDateMenu = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="4">
                    <v-label class="label_required mb-1">{{ $t("res_GridHeaders_FromStructure") }}<span> *</span></v-label>
                    <StructureUserSelector :showInternalUsers="false" :showInternalStructures="true"
                        :showExternalStructures="false" :excludeSelf="false" :isMultiple="false"
                        :selectedStructureUser="toUser" @structureUserSelectChanged="structureUserSelectChanged" :loadOnlyInScopeInternalStrucutres="true">
                    </StructureUserSelector>
                </v-col>
            </v-row>
            <v-row>
                <div class="d-flex justify-space-between align-items-center">
                    <div class="d-flex justify-space-between align-items-center">
                        <v-label class="label_required mb-1">{{ $t("res_label_MyTransfers") }}</v-label>
                        <span style="visibility:hidden;">*</span>
                        <v-checkbox v-model="filter.myTransfers" class="mt-0"></v-checkbox>
                        <v-label class="label_required mb-1">{{ $t("res_Label_getAllHierarchy") }}</v-label>
                        <span style="visibility:hidden;">*</span>
                        <v-checkbox v-model="filter.getAllHierarchy" class="mt-0"></v-checkbox>
                    </div>
                    <div class="d-flex justify-space-between align-items-center">

                    </div>
                    <div class="d-flex gap-2">
                        <v-btn @click="clearFilter()" color="light-blue">{{ $t("res_ButtonText_Clear") }}</v-btn>
                        <v-btn dense class="primary" :disabled='isSearchDisabled()' @click="search()">
                            {{ $t("res_ButtonText_Search") }}
                        </v-btn>
                    </div>
                </div>
            </v-row>
        </div>
        <hr>
        <v-row>
            <v-col cols="4">
                <v-data-table :headers="structureHeaders" :items="structures" :items-per-page="10" item-key="name"
                    @click:row="handleRowClick">
                </v-data-table>
            </v-col>
            <v-col cols="8">
                <div v-if="series[0].data.length > 0">
                    <apexchart type="bar" height="350" :options="chartOptions" :series="series"></apexchart>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <div v-if="listCorrespondences.length" class="d-flex justify-end align-right">
                <v-btn class="custom-button" @click="exportToExcelOrPdf(1)" v-tooltip="$t('res_Export_To_Excel')">
                    <v-icon class="bg-gray black--text custom-button" style="color: #388729 !important; background-image: none;">mdi-file-excel</v-icon>
                </v-btn>
                <v-btn class="custom-button" @click="exportToExcelOrPdf(2)" v-tooltip="$t('res_Export_To_Pdf')">
                    <v-icon class="bg-gray custom-button">mdi-file-pdf-box</v-icon>
                </v-btn>
            </div>
            <div class="row align-items-start m-0 pt-5 gap-2">
                <v-card class="bg-white rounded-top-corners rounded-4">
                    <v-data-table :headers="correspondenceHeaders" :items="listCorrespondences" :items-per-page="10">
                        <template v-slot:[`item.dueIn`]="{ item }">
                            <span :style="{ color: calculateDueIn(item.dueDate) > 0 ? '#15d649' : '#fa0707' }">
                                {{ calculateDueIn(item.dueDate) }}
                            </span>
                        </template>
                    </v-data-table>
                </v-card>
            </div>
        </v-row>
    </v-card>
</template>

<script>
import axios from "axios";
import constants from "@/assets/js/constants.js";
import * as utils from '@/assets/js/common.js';
import router from '../../router/index.js';
import StructureUserSelector from '@/components/StructureUserSelector.vue'

export default {
    name: "CorrespondenceDashboard",
    components: { StructureUserSelector },
    data() {
        return {
            utils: utils,
            structureHeaders: localStorage.getItem('lang') == 'en' ? [
                { text: 'Reporting Department', value: 'name', 'sortable': false },
                { text: 'Active', value: 'active', 'sortable': false },
                { text: 'Completed', value: 'completed', 'sortable': false },
                { text: 'Delayed', value: 'delayed', 'sortable': false },
                { text: 'Total', value: 'total', 'sortable': false },
            ] : [
                { text: 'القسم', value: 'name', 'sortable': false },
                { text: 'فعال', value: 'active', 'sortable': false },
                { text: 'مكتمل', value: 'completed', 'sortable': false },
                { text: 'متأخر', value: 'delayed', 'sortable': false },
                { text: 'المجموع', value: 'total', 'sortable': false },
            ],
            correspondenceHeaders: localStorage.getItem('lang') == 'en' ? [
                { text: 'Reference No.', value: 'reference', 'sortable': false },
                { text: 'Privacy', value: 'privacy', 'sortable': false },
                { text: 'Document Sender', value: 'sender', 'sortable': false },
                { text: 'Document Recepient', value: 'recepient', 'sortable': false },
                { text: 'Due In', value: 'dueIn', 'sortable': false },
                { text: 'Subject', value: 'subject', 'sortable': false },
                { text: 'Forwarded To', value: 'forwardedTo', 'sortable': false },
                { text: 'Current User', value: 'currentUser', 'sortable': false },
                { text: 'Current Structure', value: 'currentStructure', 'sortable': false },
                { text: 'Action Type', value: 'action', 'sortable': false },
            ] : [
                { text: 'الرقم المرجعي', value: 'reference', 'sortable': false },
                { text: 'الخصوصية', value: 'privacy', 'sortable': false },
                { text: 'المرسل', value: 'sender', 'sortable': false },
                { text: 'المستقبل', value: 'recepient', 'sortable': false },
                { text: 'تستحق بغضون', value: 'dueIn', 'sortable': false },
                { text: 'الموضوع', value: 'subject', 'sortable': false },
                { text: 'مرسل الى', value: 'forwardedTo', 'sortable': false },
                { text: 'المستخدم الحالي', value: 'currentUser', 'sortable': false },
                { text: 'القسم الحالي', value: 'currentStructure', 'sortable': false },
                { text: 'النوع', value: 'action', 'sortable': false },
            ],
            toUser: {},
            listCorrespondences: [],
            dataIndexToFlag: {
                0: 'Active',
                1: 'Completed',
                2: 'delayed'
            },
            currentStructure: {
                id: 0,
                name: ''
            },
            structures: [],
            counts: {},
            searchVal: '',
            filter: {
                fromDate: "",
                toDate: "",
                myTransfers: false,
                getAllHierarchy: false
            },
            fromDateMenu: false,
            toDateMenu: false,
            session: JSON.parse(sessionStorage.getItem('user_structure')),
            series: [{
                data: [],
                headerLabel: ''
            }],
            chartOptions: {
                chart: {
                    height: 350,
                    type: 'bar',
                    events: {
                        dataPointSelection: this.handleBarClick
                    }
                },
                plotOptions: {
                    bar: {
                        columnWidth: '90%',
                        distributed: true,
                    }
                },
                dataLabels: {
                    enabled: true
                },
                legend: {
                    show: true,
                },
                xaxis: {
                    categories: ["Active", "Completed", "Delayed"],
                    labels: {
                        style: {
                            fontSize: '12px'
                        }
                    }
                },
                title: {
                    text: '',
                    floating: false,
                    offsetY: 30,
                    align: 'center',
                    style: {
                        color: '#444'
                    }
                }
            },
            tableCategory: '',
            isExport: false,
            exportType: ''
        }
    },
    watch: {
    },
    methods: {
        handleRowClick(item) {
            this.series[0].data = [];
            this.listCorrespondences = [];
            window.showLoading();
            try {
                this.currentStructure.id = item.id;
                this.currentStructure.name = item.name;
                this.chartOptions.title.text = item.name;
            } catch (error) {
                console.log(error);
            } finally {
                setTimeout(() => {
                    this.series[0].data.splice(0, 3, item.active, item.completed, item.delayed);
                    window.hideLoading();
                }, 500);
            }
        },
        async getStructureAndChilds(parentId) {
            this.structures = [];
            window.showLoading();
            try {
                const res= await axios.post(constants.baseApiUrl + `Dashboard/StructureAndChilds?parentId=${parentId}&userId=${this.session.id}&fromDate=${this.filter.fromDate}&toDate=${this.filter.toDate}&myTransfers=${this.filter.myTransfers}&getAllHierarchy=${this.filter.getAllHierarchy}`);

                if (res.data !== null) {
                    res.data.map(async (element) => {
                        try {
                            this.structures.push({
                                id: element.id,
                                name: element.name,
                                active: element.correspondenceCounts.Active,
                                completed: element.correspondenceCounts.Completed,
                                delayed: element.correspondenceCounts.Delayed,
                                total: (element.correspondenceCounts.Active + element.correspondenceCounts.Completed + element.correspondenceCounts.Delayed),
                            });
                        } catch (error) {
                            console.error(`Error fetching counts for structure ${element.id}:`, error);
                        }
                    });
                }
            } catch (error) {
                console.error('Error fetching structures:', error);
            } finally {
                window.hideLoading();
            }
        },
        backToDashboardsPage() {
            router.push({ name: 'dashboards' })
        },
        clearFilter() {
            this.filter.fromDate = "";
            this.filter.toDate = "";
            this.currentStructure = {};
            this.filter.myTransfers = false;
            this.filter.getAllHierarchy = false;
        },
        search() {
            this.series[0].data = [];
            this.getStructureAndChilds(this.currentStructure.id);
        },
        isSearchDisabled() {
            return this.filter.fromDate == "" || this.filter.toDate == "" || this.currentStructure.id == 0;
        },
        handleBarClick(event, chartContext, config) {
            const dataIndex = config.dataPointIndex;
            const mappedFlag = this.dataIndexToFlag[dataIndex];
            this.tableCategory = mappedFlag;
            this.getListCorrespondences(mappedFlag);
        },
        getListCorrespondences(flag) {
            window.showLoading();

            if(this.isExport) {
                var extension = this.exportType == 1 ? '.xlsx' : '.pdf';
                axios({
                    url: constants.baseApiUrl + `Dashboard/${flag}Correspondences?structureId=${this.currentStructure.id}&userId=${this.session.id}&fromDate=${this.filter.fromDate}&toDate=${this.filter.toDate}&myTransfers=${this.filter.myTransfers}&getAllHierarchy=${this.filter.getAllHierarchy}&isExport=${this.isExport}&exportType=${this.exportType}`,
                    method: 'POST',
                    responseType: 'blob',
                })
                .then((res) => {
                        var blob = new Blob([res.data], { type: "application/octetstream" });
                        const link = window.URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.setAttribute("download", "ExportedData" + `${extension}`);
                        a.setAttribute("href", link);
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    })
                    .catch((err) => window.hideLoading())
                    .finally(() => window.hideLoading())
                    this.isExport = false;
                    this.exportType = '';
            } else {
                axios.post(constants.baseApiUrl + `Dashboard/${flag}Correspondences?structureId=${this.currentStructure.id}&userId=${this.session.id}&fromDate=${this.filter.fromDate}&toDate=${this.filter.toDate}&myTransfers=${this.filter.myTransfers}&getAllHierarchy=${this.filter.getAllHierarchy}&isExport=${this.isExport}&exportType=${this.exportType}`, { headers: constants.headers })
                    .then(res => {
                        if (res != undefined) {
                            this.listCorrespondences = res.data;
                        }
                    })
                    .catch(error => window.hideLoading())
                    .finally(() => window.hideLoading())
            }
        },
        calculateDueIn(dueDate) {
            const today = new Date();
            const dueDateTime = new Date(dueDate);
            const timeDifference = dueDateTime - today;
            const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));

            return `${daysDifference} days`;
        },
        structureUserSelectChanged(selectedItem) {
            if (selectedItem) {
                this.currentStructure = selectedItem;
            } else {
                this.currentStructure = { id: 0, name: "" };
            }
        },
        exportToExcelOrPdf(exportType) {
            this.isExport = true;
            this.exportType = exportType;
            this.getListCorrespondences(this.tableCategory);
        },
    },
}
</script>